/**
 * @fileoverview The entry point for the application.
 *
 * @example
 * // Basic usage
 * import { createRoot } from 'react-dom/client'
 * import i18n from 'i18next'
 * import { initReactI18next } from 'react-i18next'
 *
 * import App from './components/App'
 * import enUS from './i18n/en_US.json'
 *
 * const element = document.getElementById('app')
 *
 * i18n.use(initReactI18next).init({
 *     resources: {
 *         en_US: {
 *             translation: enUS,
 *         },
 *     },
 *     lng: 'en_US',
 *     fallbackLng: 'en_US',
 * })
 */

import i18n from 'i18next'
import { createRoot } from 'react-dom/client'
import { initReactI18next } from 'react-i18next'

import App from './components/App'
import enUS from './i18n/en_US.json'

const element = document.getElementById('app')

i18n.use(initReactI18next).init({
    resources: {
        en_US: {
            translation: enUS,
        },
    },
    lng: 'en_US',
    fallbackLng: 'en_US',
})

if (element) {
    const root = createRoot(element)
    root.render(<App />)
}
